import { render, staticRenderFns } from "./EditPlatformComponent.vue?vue&type=template&id=34631057&"
import script from "./EditPlatformComponent.vue?vue&type=script&lang=js&"
export * from "./EditPlatformComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports